import { Book } from "../../shared/book.model";
import { Component, Input, OnInit } from "@angular/core";

declare let alertify : any;
declare let localforage : any;
declare let window : any;

@Component({
	selector: "app-book",
	templateUrl: "./book.component.html",
	styleUrls: ["./book.component.css"],
})
export class BookComponent implements OnInit {
	@Input() listBook! : Book[];
	constructor() {
	}

	ngOnInit() : void {
	}
	
	getCdnImage(url : string) {
		let s = url || '';
		let fix = 'http://static.bilet.vn/static/';
		if (s.length > fix.length)
			s = window['__cdn_static'] + s.substr(fix.length);
		console.log(s);
		return s;
	}
	
}